import axios from "axios";
import React, {
  useEffect,
  useState,
  useContext,
  Fragment,
  useMemo,
} from "react";
import { Link, useHistory } from "react-router-dom";
import UserDataContext from "../../context/UserDataContext";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Button } from "@mui/material";
import { MRT_Localization_DE } from "material-react-table/locales/de";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { translate } from "../../translations";

export default function OrderApproval() {
  const history = useHistory();
  const [orders, setOrders] = useState([]);
  const { userData } = useContext(UserDataContext);
  const token = localStorage.getItem("token");
  const project = localStorage.getItem("currentProjectID");
  var date = new Date();
  const [timePeriod, setTimePeriod] = useState({
    startDate: new Date(date.getFullYear(), date.getMonth(), 1, 3)
      .toISOString()
      .substr(0, 10),
    endDate: new Date(date.getFullYear(), date.getMonth() + 1, 1)
      .toISOString()
      .substr(0, 10),
  });

  async function getOrders() {
    const userRes = await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/orders/list`,
      { project, startDate: timePeriod.startDate, endDate: timePeriod.endDate },
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    setOrders(userRes.data.filter((order) => order.status === "erledigt"));
    if (
      userData &&
      userData.permissions &&
      !userData.permissions[project].isProjectAdmin
    ) {
      setOrders(
        userRes.data.filter(
          (order) =>
            userData.permissions[project].kostenstellen.includes(
              order.service.kostenstelle._id
            ) && order.status === "erledigt"
        )
      );
    }
  }

  let columns = [
    {
      accessorKey: "status",
      header: "Status",
    },
    {
      accessorKey: "service.pos_name",
      header: "Pos. Name",
    },
    {
      accessorKey: "service.pos_nr",
      header: "Pos. Nr.",
    },
    {
      accessorKey: "service.kostenstelle.name",
      header: "Kst.",
    },
    {
      accessorKey: "orderDate",
      header: "Datum",
      muiTableBodyCellProps: ({ row }) => {
        if (
          row.original.status === "offen" &&
          new Date(row.original.orderDate) < new Date()
        ) {
          return { sx: { backgroundColor: "#FFCCCB" } };
        }
      },
    },
    {
      accessorKey: "comment",
      header: "Kommentar",
    },
    {
      accessorKey: "_id",
      header: translate("optionen"),
      enableHiding: false,
      Cell: ({ cell, row }) => (
        <>
          {cell.row.original.active && (
            <Link
              to={`/edit-order/${cell.getValue()}`}
              className="whitespace-nowrap inline-flex items-center justify-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                />
              </svg>
            </Link>
          )}
        </>
      ),
    },
  ];

  let table = useMaterialReactTable({
    columns,
    data: orders,
    localization: MRT_Localization_DE,
    enableSelectAll: true,

    enableRowSelection: true,
    renderTopToolbarCustomActions: ({ table }) => (
      <Button
        startIcon={<CheckCircleOutlineIcon />}
        onClick={async () => {
          const selectedRows = table.getSelectedRowModel().rows;
          let updateOrders = [];
          selectedRows.forEach((order) => {
            updateOrders.push(order.original._id);
          });
          const apiRes = await axios.post(
            `${process.env.REACT_APP_BACKEND}/services/orders/approveMultiple`,
            { updateOrders, userData },
            {
              headers: {
                jwttoken: token,
              },
            }
          );
          history.go(0);
        }}
      >
        Auswahl als "abgenommen" markieren
      </Button>
    ),
    initialState: {
      columnOrder: [
        "status",
        "service.pos_name",
        "service.pos_nr",
        "service.kostenstelle.name",
        "orderDate",
        "comment",
        "_id",
      ],
      pagination: { pageSize: 25, pageIndex: 0 },
    },
    enableColumnOrdering: true,
    enableGlobalFilter: true,
  });

  useEffect(() => {
    getOrders();
  }, [timePeriod, userData, table.getState().rowSelection]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-between">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Bestellungen abnehmen
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            Hier finden Sie eine Übersicht aller <b>erledigter</b> Bestellungen
            im ausgewählten Zeitraum.
          </p>
        </div>
        <div className="px-4 py-5 sm:px-6 flex justify-end md:flex-1 lg:w-0">
          <div class="flex">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Von:
            </span>
            <input
              type="date"
              required="true"
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  startDate: e.target.value,
                })
              }
              value={timePeriod.startDate}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            />
          </div>

          <div class="ml-3 flex">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Bis:
            </span>
            <input
              type="date"
              required="true"
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  endDate: e.target.value,
                })
              }
              value={timePeriod.endDate}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            />
          </div>
        </div>
      </div>
      <div className="bg-white w-full  shadow overflow-auto sm:rounded-lg flex justify-between my-5 border-b border-gray-200 shadow  w-full sm:rounded-lg"></div>
      <MaterialReactTable table={table} />
    </>
  );
}
